import React, { useState } from 'react';
import { useTheme } from '../ThemeContext';

const ReadMore = ({ children, maxHeight = 180 }) => {
  const [expanded, setExpanded] = useState(false);
  const { isInstitutional } = useTheme();

  const accent = isInstitutional ? '#C4532D' : '#00FF41';

  return (
    <div data-testid="read-more-wrapper">
      <div
        className="relative overflow-hidden transition-all duration-500"
        style={{ maxHeight: expanded ? '5000px' : `${maxHeight}px` }}
      >
        {children}
        {!expanded && (
          <div className="absolute bottom-0 left-0 right-0 h-20 pointer-events-none"
            style={{ background: isInstitutional
              ? 'linear-gradient(transparent, #FAF9F6)'
              : 'linear-gradient(transparent, #050505)'
            }}
          />
        )}
      </div>
      <button
        onClick={() => setExpanded(!expanded)}
        data-testid="read-more-btn"
        className="mt-3 text-xs font-black uppercase tracking-[0.2em] transition-colors"
        style={{ color: accent, fontFamily: isInstitutional ? "'Titillium Web', sans-serif" : 'monospace' }}
      >
        {expanded ? 'CHIUDI' : 'CONTINUA'} {expanded ? '\u25B2' : '\u25BC'}
      </button>
    </div>
  );
};

export default ReadMore;
